import { createBrowserRouter } from 'react-router';
import { DEFAULT_LANGUAGE } from '@@/languageConfig';
import { AppRoutes } from '@features/routing/routesObject';
import MainLayout from '@layouts/main-layout/MainLayout';
import { AdminLayout } from '@layouts/admin-layout/AdminLayout';
import Home from '@pages/home/Home';
import { About } from '@pages/about/About';
import { History } from '@pages/history/History';
import { Faq } from '@pages/faq/Faq';
import Contact from '@pages/contact/Contact';
import Gallery from '@pages/gallery/Gallery';
import Order from '@pages/order/Order';
import OrderCat from '@pages/order-cat/OrderCat';
import { Partners } from '@pages/partners/Partners';
import PartnersRegistration from '@pages/partners-registration/PartnersRegistration';
import PartnersOrder from '@pages/partners-order/PartnersOrder';
import NotFoundPage from '@pages/not-found/NotFoundPage';
import SalesNetwork from '@pages/sales-network/SalesNetwork';
import ThankYou from '@pages/thank-you/ThankYou';
import { ArticleList } from '@pages/admin/article-list/ArticleList';
import { NewArticle } from '@pages/admin/article/NewArticle';
import { ExistArticle } from '@pages/admin/article/ExistArticle';
import { AuthorizedPage } from '@features/authentication/AuthorizedPage';
import AppLogic from '@layouts/app-logic/AppLogic';



export const router = createBrowserRouter([
	{
		path: AppRoutes[DEFAULT_LANGUAGE].basePath,
		element: <AppLogic />,
		children: [
			{
				path: AppRoutes[DEFAULT_LANGUAGE].basePath,
				element: <MainLayout />,
				children: [
					{
						index: true,
						element: <Home />
					},
					{
						path: AppRoutes[DEFAULT_LANGUAGE].about,
						element: <About />
					},
					{
						path: AppRoutes[DEFAULT_LANGUAGE].history,
						element: <History />
					},
					{
						path: AppRoutes[DEFAULT_LANGUAGE].order,
						element: <Order />
					},
					{
						path: AppRoutes[DEFAULT_LANGUAGE].orderSelect,
						element: <Order />
					},
					{
						path: AppRoutes[DEFAULT_LANGUAGE].catOrder,
						element: <OrderCat />
					},
					{
						path: AppRoutes[DEFAULT_LANGUAGE].gallery,
						element: <Gallery />
					},
					{
						path: AppRoutes[DEFAULT_LANGUAGE].partners,
						element: <Partners />
					},
					{
						path: AppRoutes[DEFAULT_LANGUAGE].partnersRegistration,
						element: <PartnersRegistration />
					},
					{
						path: AppRoutes[DEFAULT_LANGUAGE].partnersOrder,
						element: <PartnersOrder />
					},
					{
						path: AppRoutes[DEFAULT_LANGUAGE].faq,
						element: <Faq />
					},
					{
						path: AppRoutes[DEFAULT_LANGUAGE].contact,
						element: <Contact />
					},
					{
						path: AppRoutes[DEFAULT_LANGUAGE].salesNetwork,
						element: <SalesNetwork />
					},
					{
						path: AppRoutes[DEFAULT_LANGUAGE].thankYouOrder,
						element: <ThankYou />
					},
					{
						path: AppRoutes[DEFAULT_LANGUAGE].thankYouRegistration,
						element: <ThankYou registration={true} />
					},
				]
			},
			{
				element: <AdminLayout />,
				children: [
					{
						element: <AuthorizedPage />,
						children: [
							{
								path: AppRoutes[DEFAULT_LANGUAGE].admin,
								element: <ArticleList />,
							},
							{
								path: AppRoutes[DEFAULT_LANGUAGE].article,
								children: [
									{
										index: true,
										element: <NewArticle />,
									},
									{
										path: ':id',
										element: <ExistArticle />
									}
								],
							}
						]
					},
				]
			},
			{
				element: <MainLayout />,
				children: [
					{
						path: "*",
						element: <NotFoundPage />
					}
				]
			}
		]
	}
]);